import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import CareersHero from './components/CareersHero';
import WhyWorkHere from './components/WhyWorkHere';
import CareersApplicationForm from './components/CareersApplicationForm';

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <CareersHero />

      {/* Intro paragraph */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-lg text-gray-700 leading-relaxed">
            Deer Point Contracting is growing, and we are looking for skilled construction professionals who share our commitment to quality, safety, and integrity. Whether you are a seasoned project manager, an experienced superintendent, or a skilled tradesperson looking for your next opportunity, we want to hear from you.
          </p>
        </div>
      </section>

      <WhyWorkHere />
      <CareersApplicationForm />
      <Footer />
    </div>
  );
}
